import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'sq',
  months: [
    'janar',
    'shkurt',
    'mars',
    'prill',
    'maj',
    'qershor',
    'korrik',
    'gusht',
    'shtator',
    'tetor',
    'nëntor',
    'dhjetor',
  ],
  monthsShort: ['jan', 'shk', 'mar', 'pri', 'maj', 'qer', 'korr', 'gush', 'sht', 'tet', 'nën', 'dhj'],
  weekdays: ['e diel', 'e hënë', 'e martë', 'e mërkurë', 'e enjte', 'e premte', 'e shtunë'],
  weekdaysMin: ['d', 'h', 'm', 'm', 'e', 'p', 'sh'],
  weekdaysShort: ['die', 'hën', 'mar', 'mër', 'enj', 'pre', 'sht'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'D.M.YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY, HH:mm',
    'LLL-Y': 'D MMMM, HH:mm',
    LLLL: 'dddd, D MMMM YYYY, HH:mm',
    'LLLL-Y': 'dddd D MMMM, HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D MMM',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY, HH:mm',
    'lll-Y': 'D MMM, HH:mm',
    llll: 'ddd, D MMM YYYY, HH:mm',
    'llll-Y': 'ddd, D MMM, HH:mm',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'p.d.', pm: 'm.d.', AM: 'p.d.', PM: 'm.d.' },
  past: {
    y: { one: '%s vit më parë', other: '%s vjet më parë' },
    M: { one: '%s muaj më parë', other: '%s muaj më parë' },
    w: { one: '%s javë më parë', other: '%s javë më parë' },
    d: { one: '%s ditë më parë', other: '%s ditë më parë' },
    h: { one: '%s orë më parë', other: '%s orë më parë' },
    m: { one: '%s min më parë', other: '%s min më parë' },
    s: { one: '%s sek më parë', other: '%s sek më parë' },
  },
  future: {
    y: { one: 'pas %s viti', other: 'pas %s vjetësh' },
    M: { one: 'pas %s muaji', other: 'pas %s muajsh' },
    w: { one: 'pas %s jave', other: 'pas %s javësh' },
    d: { one: 'pas %s dite', other: 'pas %s ditësh' },
    h: { one: 'pas %s ore', other: 'pas %s orësh' },
    m: { one: 'pas %s min', other: 'pas %s min' },
    s: { one: 'pas %s sek', other: 'pas %s sek' },
  },
  pastLong: {
    y: { one: '%s vit më parë', other: '%s vjet më parë' },
    M: { one: '%s muaj më parë', other: '%s muaj më parë' },
    w: { one: '%s javë më parë', other: '%s javë më parë' },
    d: { one: '%s ditë më parë', other: '%s ditë më parë' },
    h: { one: '%s orë më parë', other: '%s orë më parë' },
    m: { one: '%s minutë më parë', other: '%s minuta më parë' },
    s: { one: '%s sekondë më parë', other: '%s sekonda më parë' },
  },
  futureLong: {
    y: { one: 'pas %s viti', other: 'pas %s vjetësh' },
    M: { one: 'pas %s muaji', other: 'pas %s muajsh' },
    w: { one: 'pas %s jave', other: 'pas %s javësh' },
    d: { one: 'pas %s dite', other: 'pas %s ditësh' },
    h: { one: 'pas %s ore', other: 'pas %s orësh' },
    m: { one: 'pas %s minute', other: 'pas %s minutash' },
    s: { one: 'pas %s sekonde', other: 'pas %s sekondash' },
  },
  abbr: {
    y: { one: '%s vit', other: '%s vjet' },
    M: { one: '%s muaj', other: '%s muaj' },
    w: { one: '%s javë', other: '%s javë' },
    d: { one: '%s ditë', other: '%s ditë' },
    h: { one: '%s orë', other: '%s orë' },
    m: { one: '%s min.', other: '%s min.' },
    s: { one: '%s sek.', other: '%s sek.' },
  },
  full: {
    y: { one: '%s vit', other: '%s vjet' },
    M: { one: '%s muaj', other: '%s muaj' },
    w: { one: '%s javë', other: '%s javë' },
    d: { one: '%s ditë', other: '%s ditë' },
    h: { one: '%s orë', other: '%s orë' },
    m: { one: '%s minutë', other: '%s minuta' },
    s: { one: '%s sekondë', other: '%s sekonda' },
  },
  justNow: 'tani',
  yesterday: 'dje',
  today: 'sot',
  tomorrow: 'nesër',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s, %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM YYYY', end: 'ddd, D MMM YYYY' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM YYYY' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    yt: { start: 'D MMM YYYY, HH:mm', end: 'D MMM YYYY, HH:mm' },
    mt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    dt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY, HH:mm', end: 'D MMM YYYY, HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'sq';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'p.d.' : 'p.d.';
    } else {
      return isLowerCase ? 'm.d.' : 'm.d.';
    }
  },
};
